import { newrankExhibition } from '../assets/js/api'

export default {
  path: '/user',
  component: () => import('@/components/user'),
  children: [
    {
      path: '',
      name: 'Info',
      component: () => import('@/components/user/info')
    },
    {
      path: 'profile',
      name: 'Profile',
      component: () => import('@/components/user/profile')
    },
    {
      path: 'rankcoin',
      name: 'Rankcoin',
      component: () => import('@/components/user/rankcoin')
    },
    {
      path: 'account',
      name: 'Account',
      component: () => import('@/components/user/account')
    },
    {
      path: 'updateHeadImgSuc',
      name: 'UpdateHeadImgSuc',
      component: () => import('@/components/user/updateHeadImgSuc')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/user.js